import {Injectable, Injector} from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {AuthenticationService} from '../../services/authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  public constructor(private injector: Injector) {
  }

  public intercept(req: HttpRequest<any>,
                   next: HttpHandler): Observable<HttpEvent<any>> {

    let clonedRequest: HttpRequest<any>;

    clonedRequest = req.clone({
        headers: this.makeRequestHeader(req.headers)
    });

    return next.handle(clonedRequest);
  }

  private makeRequestHeader(httpHeaders: HttpHeaders) {
    const auth = this.injector.get(AuthenticationService);
    if (!httpHeaders.keys().length) {
      httpHeaders = httpHeaders.set('Content-Type', 'application/json;charset=utf-8');
      httpHeaders = httpHeaders.set('Accept', 'application/json');
      httpHeaders = httpHeaders.set('Access-Control-Allow-Origin', '*');
    }
    const token = auth.getCurrentToken();
    if (token) {
      httpHeaders = httpHeaders.set('Authorization', 'Bearer ' + token);
    }
    return httpHeaders;
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/interceptor/auth.interceptor.ts